import React, { useState, useEffect } from 'react';
import { ArrowLeft01Icon, ArrowRight01Icon } from 'hugeicons-react';
import '../../../Styles/Layout/MiniDisplays/BranchToggle.css';

interface BranchToggleProps {
  currentBranch: number;
  totalBranches: number;
  onBranchChange: (branchNumber: number) => void;
}

const BranchToggle: React.FC<BranchToggleProps> = ({ 
  currentBranch = 1, 
  totalBranches = 1, 
  onBranchChange 
}) => {
  const [branch, setBranch] = useState(currentBranch);

  useEffect(() => {
    setBranch(currentBranch);
  }, [currentBranch]);

  const handlePrevious = () => {
    if (branch > 1) {
      const newBranch = branch - 1;
      setBranch(newBranch);
      onBranchChange(newBranch);
    }
  };

  const handleNext = () => {
    if (branch < totalBranches) {
      const newBranch = branch + 1;
      setBranch(newBranch);
      onBranchChange(newBranch);
    }
  };

  return (
    <div className="branch-toggle">
      <button 
        className="branch-button" 
        onClick={handlePrevious} 
        disabled={branch <= 1}
        aria-label="Previous branch"
      >
        <ArrowLeft01Icon size={20} />
      </button>
      
      <div className="branch-counter">
        <span>{branch}</span>
        <span className="branch-separator">/</span>
        <span>{totalBranches}</span>
      </div>
      
      <button 
        className="branch-button" 
        onClick={handleNext} 
        disabled={branch >= totalBranches}
        aria-label="Next branch"
      >
        <ArrowRight01Icon size={20} />
      </button>
    </div>
  );
};

export default BranchToggle;

